import React, { createContext, useMemo } from "react";

export const ThemeContext = createContext({
    themeMap: {},
});

export const ThemeProvider = ({ themeMap, children }) => {
    const contextValue = useMemo(() => ({
        themeMap,
    }), [themeMap]);

    return (
        <ThemeContext.Provider value={contextValue}>
            {children}
        </ThemeContext.Provider>
    )
} 